module.exports = __webpack_public_path__ + "static/optimo-zaleta-1-78ae4778139f5fee0eaf9139bc68b33b.png";